import { render, staticRenderFns } from "./getTicketMethods.vue?vue&type=template&id=0f496154&scoped=true&"
import script from "./getTicketMethods.vue?vue&type=script&lang=ts&"
export * from "./getTicketMethods.vue?vue&type=script&lang=ts&"
import style0 from "./getTicketMethods.vue?vue&type=style&index=0&id=0f496154&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f496154",
  null
  
)

export default component.exports